import { SystemStyleObject } from '@chakra-ui/react';
import {
  SIDEBAR_KEY,
  getMaxWidth,
  getMinWidth,
  getWidth,
} from 'app/utils/hooks';

export const getStyles = ({
  forceCompactMode,
  isDragging,
}: {
  forceCompactMode: boolean;
  isDragging: boolean;
}) => {
  const rootSx = {
    zIndex: 1,
    mx: 2,
    flexShrink: 0,
    position: 'relative',
    width: getWidth(SIDEBAR_KEY),
    minW: getMinWidth(SIDEBAR_KEY),
    maxW: getMaxWidth(SIDEBAR_KEY),
  };

  const wrapperSx = {
    position: 'absolute',
    width: 'inherit',
    maxWidth: 'inherit',
  };

  const contentSx = {
    alignItems: 'baseline',
    width: 'inherit',
    gap: 1,
    overflow: 'hidden',
  };

  const cardSx = {
    w: 'full',
    py: 6,
    gap: 1,
    rounded: 6,
  };

  const sidebarResizeLineSx: SystemStyleObject = {
    position: 'absolute',
    right: 0,
    height: 'full',
    px: 0.5,
    '& div': {
      w: 0.5,
      h: 'full',
      bg: isDragging ? 'B.80' : 'none',
    },
    _hover: {
      '& div': {
        ...(!forceCompactMode ? { bg: 'B.80' } : {}),
      },
    },
  };

  return { rootSx, wrapperSx, contentSx, cardSx, sidebarResizeLineSx };
};
